import PropTypes from 'prop-types';

// Lib
import {
    INSTAGRAM,
    FACEBOOK,
    LINKEDIN,
    PINTEREST,
    TWITTER,
    TIKTOK,
    TIKTOK_BUSINESS,
    YOUTUBE
} from '@/lib/socialProfile';

// Component
import InstagramAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/instagram';
import FacebookAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/facebook';
import LinkedinAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/linkedin';
import TwitterAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/twitter';
import TiktokAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/tiktok';
import YoutubeAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/youtube';
import InstagramAlbumStory from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/instagram/InstagramAlbumStory';
import PinterestAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/pinterest';

const AlbumPost = ({ network, albumType, ...restProps }) => {
    switch (network) {
        case INSTAGRAM:
            if (albumType === 'stories') {
                return <InstagramAlbumStory {...restProps} />;
            }
            return <InstagramAlbumPost {...restProps} />;
        case FACEBOOK:
            return <FacebookAlbumPost {...restProps} />;
        case LINKEDIN:
            return <LinkedinAlbumPost {...restProps} />;
        case TWITTER:
            return <TwitterAlbumPost {...restProps} />;
        case TIKTOK:
        case TIKTOK_BUSINESS:
            return <TiktokAlbumPost {...restProps} />;
        case YOUTUBE:
            return <YoutubeAlbumPost {...restProps} />;
        case PINTEREST:
            return <PinterestAlbumPost {...restProps} />;
        default:
            return <InstagramAlbumPost {...restProps} />;
    }
};

AlbumPost.propTypes = {
    network: PropTypes.oneOf([
        INSTAGRAM,
        FACEBOOK,
        LINKEDIN,
        PINTEREST,
        TWITTER,
        TIKTOK,
        TIKTOK_BUSINESS,
        YOUTUBE
    ])
};

export default AlbumPost;
